// extracted by mini-css-extract-plugin
export default {"ThreeOffersView":"styles_ThreeOffersView__Yiyuj","absoluteJobOffer":"styles_absoluteJobOffer__Et-AZ"};